import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { ISwitcherProps } from 'components/uiKit/Switcher/Switcher'
import Switcher from 'components/uiKit/Switcher/Switcher'

const FieldSwitcher = ({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<ISwitcherProps, boolean>) => {
  const handleChange = useCallback((value: boolean) => onChange({ name, value }), [name, onChange])

  return <Switcher {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldSwitcher) as typeof FieldSwitcher
